import type { Place } from '../types/warehouse.types';

/**
 * Check if mouse is over an isometric place
 * Tests both the front rectangle and the top/right isometric faces
 */
export function isMouseOverPlace(mouseX: number, mouseY: number, place: Place): boolean {
  if (!place.clickGeometry) return false;

  const { levelX, levelY, placeWidth, placeHeight, isoDepthX, isoDepthY } = place.clickGeometry;

  // Front rectangle
  if (mouseX >= levelX && mouseX <= levelX + placeWidth && mouseY >= levelY && mouseY <= levelY + placeHeight) {
    return true;
  }

  const isInsideParallelogram = (p: any, p1: any, p2: any, p4: any) => {
    const v1 = { x: p2.x - p1.x, y: p2.y - p1.y };
    const v2 = { x: p4.x - p1.x, y: p4.y - p1.y };
    const q = { x: p.x - p1.x, y: p.y - p1.y };
    const det = (v1.x * v2.y - v1.y * v2.x);
    if (det === 0) return false;
    const cross1 = (q.x * v2.y - q.y * v2.x) / det;
    const cross2 = (v1.x * q.y - v1.y * q.x) / det;
    return (cross1 >= 0 && cross1 <= 1 && cross2 >= 0 && cross2 <= 1);
  };

  const p = { x: mouseX, y: mouseY };
  const topLeft = { x: levelX, y: levelY };
  const topRight = { x: levelX + placeWidth, y: levelY };
  const backLeft = { x: levelX + isoDepthX, y: levelY + isoDepthY };
  if (isInsideParallelogram(p, topLeft, topRight, backLeft)) return true;

  const bottomRight = { x: levelX + placeWidth, y: levelY + placeHeight };
  const backTopRight = { x: levelX + placeWidth + isoDepthX, y: levelY + isoDepthY };
  if (isInsideParallelogram(p, topRight, backTopRight, bottomRight)) return true;

  return false;
}

/**
 * Check if mouse is over a 2D rectangular place (for 2D projection view)
 */
export function isMouseOverPlace2D(mouseX: number, mouseY: number, place: Place): boolean {
  if (!place.clickGeometry2D) return false;
  const { levelX, levelY, placeWidth, placeHeight } = place.clickGeometry2D;
  return mouseX >= levelX && mouseX <= levelX + placeWidth && mouseY >= levelY && mouseY <= levelY + placeHeight;
}
